export const openClearFeed = () => {
  if (typeof window.ClearFeed?.open !== 'function') {
    return false
  }

  window.ClearFeed.open()
  return true
}
